var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"game-section"},[_vm._m(0),_c('div',{staticClass:"game-grid"},_vm._l((_vm.allGames),function(game,index){return _c('GameCard',{key:index,attrs:{"title":game}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header"},[_c('div',{staticClass:"section-title"},[_c('h2',[_vm._v("All Games")])])])
}]

export { render, staticRenderFns }